import React from 'react';
import { NavLink } from 'react-router-dom';
import hero_image from '../../assets/hero_image.png';
import hero_image_back from '../../assets/hero_image_back.png';
import Heart from '../../assets/heart.png';
import Calories from '../../assets/calories.png';
import NumberCounter from 'number-counter';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaFireAlt, FaArrowRight } from 'react-icons/fa';

const HeroSection = () => {
  const transition = { type: 'spring', duration: 2.5 };
  const mobile = window.innerWidth <= 768;

  return (
    <div className="flex flex-col lg:flex-row justify-between relative px-4 md:px-12 py-8 min-h-screen pt-12 lg:pt-8" id="home">
      {/* Background Ambient Red Blurs & Designing Elements */}
      <div className="absolute w-[22rem] md:w-[32rem] h-[32rem] left-0 top-10 bg-red-600/25 rounded-full blur-[180px] pointer-events-none -z-10" />
      <div className="absolute w-[24rem] h-[28rem] right-0 bottom-0 bg-red-800/20 rounded-full blur-[170px] pointer-events-none -z-10" />

      {/* Decorative Sport Lines */}
      <div className="absolute top-20 right-1/4 w-72 h-72 rounded-full border border-red-600/10 pointer-events-none -z-10" />
      <div className="absolute top-16 right-1/4 w-96 h-96 rounded-full border border-dashed border-red-600/10 pointer-events-none -z-10" />

      {/* Left Hero */}
      <div className="flex-1 lg:flex-[3] flex flex-col gap-6 md:gap-8 p-2 md:p-6 z-10">
        {/* The Best Ad Pill */}
        <div className="relative bg-[#1a1c24]/90 border border-red-500/20 rounded-full w-fit px-4 py-2.5 text-white uppercase text-xs md:text-sm font-semibold flex items-center justify-start self-center lg:self-start shadow-xl backdrop-blur-md">
          <motion.div
            className="absolute bg-gradient-to-r from-red-600 to-red-700 w-24 md:w-28 h-[80%] left-2 rounded-full z-0 shadow-md shadow-red-600/40"
            initial={{ left: mobile ? '140px' : '220px' }}
            whileInView={{ left: '6px' }}
            transition={{ ...transition, type: 'tween' }}
          />
          <span className="z-10 relative flex items-center gap-2 pl-2 text-[11px] sm:text-xs">
            <FaFireAlt className="text-white" /> 3 Units Across Coimbatore
          </span>
        </div>

        {/* Hero Heading */}
        <div className="flex flex-col gap-3 text-4xl sm:text-5xl md:text-7xl font-black uppercase text-white tracking-wide items-center lg:items-start text-center lg:text-left leading-none">
          <div className="flex gap-4 flex-wrap justify-center lg:justify-start">
            <span className="text-transparent [-webkit-text-stroke:_1.5px_white]">BE YOUR</span>
          </div>
          <div>
            <span>OWN IDOL</span>
          </div>
          <div className="text-xs sm:text-sm md:text-base font-normal normal-case tracking-normal max-w-xl text-gray-300 mt-2 leading-relaxed">
            Welcome to <strong className="text-white font-bold">IDOL FITNESS ZONE</strong>. South India's premier gym network with 3 specialized units offering Olympic equipment, expert coaching, and personalized fat loss & muscle programs.
          </div>
        </div>

        {/* Figures / Stats */}
        <div className="flex gap-6 md:gap-10 justify-center lg:justify-start pt-2">
          <div className="flex flex-col">
            <span className="text-white text-2xl md:text-3xl font-extrabold text-red-400">
              <NumberCounter end={3} start={1} delay="1" preFix="" postFix=" Units" />
            </span>
            <span className="text-gray-400 uppercase text-[10px] md:text-xs tracking-wider">in Coimbatore</span>
          </div>
          <div className="flex flex-col border-l border-white/10 pl-6">
            <span className="text-white text-2xl md:text-3xl font-extrabold">
              <NumberCounter end={140} start={69} delay="2" preFix="+" />
            </span>
            <span className="text-gray-400 uppercase text-[10px] md:text-xs tracking-wider">Expert Coaches</span>
          </div>
          <div className="flex flex-col border-l border-white/10 pl-6">
            <span className="text-white text-2xl md:text-3xl font-extrabold text-white">
              <NumberCounter end={978} start={779} delay="2" preFix="+" />
            </span>
            <span className="text-gray-400 uppercase text-[10px] md:text-xs tracking-wider">Active Members</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap gap-4 font-semibold justify-center lg:justify-start pt-2">
          <NavLink
            to="/contact"
            className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-500 hover:to-red-600 text-white px-7 py-3.5 rounded-xl shadow-lg shadow-red-600/30 transition-all flex items-center gap-2 text-xs uppercase tracking-wider font-bold group"
          >
            <span>Start Your Fitness Journey</span>
            <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
          </NavLink>
          <NavLink
            to="/contact"
            className="bg-white/5 hover:bg-white/10 text-white px-7 py-3.5 border border-white/20 hover:border-red-500/50 rounded-xl transition-all text-xs uppercase tracking-wider font-semibold backdrop-blur-md"
          >
            Book a Fitness Consultation
          </NavLink>
        </div>

        {/* 3 Branch Quick Badges */}
        <div className="pt-2 flex flex-wrap items-center justify-center lg:justify-start gap-2 text-[11px] text-gray-400">
          <span className="font-bold text-red-500 uppercase flex items-center gap-1">
            <FaMapMarkerAlt /> Locations:
          </span>
          <span className="bg-white/5 px-2.5 py-1 rounded-lg border border-white/10 text-gray-200">Unit 1: Chettipalayam JJ Nagar</span>
          <span className="bg-white/5 px-2.5 py-1 rounded-lg border border-white/10 text-gray-200">Unit 2: Pappampatti Pirivu</span>
          <span className="bg-white/5 px-2.5 py-1 rounded-lg border border-white/10 text-gray-200">Unit 3: Peedampalli</span>
        </div>
      </div>

      {/* Right Hero */}
      <div className="flex-1 relative rounded-3xl p-6 lg:p-0 mt-10 lg:mt-0 flex flex-col items-center lg:block min-h-[460px]">
        {/* Heart Rate Card */}
        <motion.div
          initial={{ right: '-1rem' }}
          whileInView={{ right: '3rem' }}
          transition={transition}
          className="flex flex-col gap-1 bg-[#1a1c24]/90 backdrop-blur-xl border border-white/10 p-4 rounded-2xl w-fit items-start absolute left-4 lg:left-auto lg:right-12 top-4 lg:top-12 z-20 shadow-2xl"
        >
          <img src={Heart} alt="Heart" className="w-7" />
          <span className="text-gray-400 text-[10px] uppercase font-bold tracking-wider">Heart Rate</span>
          <span className="text-white text-xl font-bold">116 bpm</span>
        </motion.div>

        {/* Hero Image */}
        <img
          src={hero_image}
          alt="Athlete"
          className="relative lg:absolute lg:top-20 lg:right-24 w-56 sm:w-72 lg:w-96 z-10 mx-auto drop-shadow-[0_20px_35px_rgba(229,27,36,0.35)]"
        />

        {/* Back Decoration Graphic */}
        <motion.img
          initial={{ right: '11rem' }}
          whileInView={{ right: '18rem' }}
          transition={transition}
          src={hero_image_back}
          alt="Decoration"
          className="absolute top-8 right-6 lg:right-72 -z-0 w-44 lg:w-56 opacity-50 lg:opacity-90"
        />

        {/* Calories Card */}
        <motion.div
          initial={{ right: '35rem' }}
          whileInView={{ right: '22rem' }}
          transition={transition}
          className="flex gap-4 bg-[#1a1c24]/90 backdrop-blur-xl border border-white/10 p-4 rounded-2xl w-fit relative lg:absolute top-4 lg:top-[24rem] left-4 lg:left-auto lg:right-80 z-20 shadow-2xl"
        >
          <img src={Calories} alt="Calories" className="w-9 h-9 object-contain" />
          <div className="flex flex-col justify-between">
            <span className="text-gray-400 text-[10px] uppercase font-bold tracking-wider">Calories Burned</span>
            <span className="text-white text-lg font-bold">220 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default HeroSection;